import { configureStore } from "@reduxjs/toolkit";

import stepperReducer from "./stepperSlice";
import userReducer from "./userSlice";
export default configureStore({
    reducer: {
        user: userReducer,
        stepper: stepperReducer,
    },
});
